export const Tiles = {
  essentials: 'Essentials',
  standard: 'Standard',
  premium: 'Premium',
};

export const MVS = {
  default: 10,
  min: 1,
  max: 500,
};

export const Users = {
  default: 10,
  min: 1,
  max: 500,
};

export const RU_RATIO = 100;

export const SAAS = 'saas';
export const SOFTWARE = 'software';

// Storage Quantity in GB
export const StorageQuantity = {
  essentials: 240, // changed as per QRADAR-1116
  standard: 192, // changed as per QRADAR-1116
};

// Tiers only for DPSM package
export const Tiers = {
  '1000': 1000,
  '2000': 2000,
  '4000': 4000,
  '6000': 6000,
  '8000': 8000,
  Infinity: 1000000000,
};

export const checkForChina = (country: string) => {
  return country === 'CHN';
};

export const AWS_SALES =
  'https://aws.amazon.com/marketplace/pp/prodview-zw7rst7t566c2?sr=0-6&ref_=beagle&applicationId=AWSMPContessa';
